module.exports = __webpack_public_path__ + "static/img/bg_shehuizeren.09cebc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_shehuizeren.png
// module id = xe7Q
// module chunks = 15